import React from 'react';

export interface FieldsetProps {
  children?: React.ReactNode;
  className?: string;
  id?: string;
  header?: string;
}

export const Fieldset: React.FC<FieldsetProps> = ({
  children,
  className,
  id,
  header,
}) => {
  return (
    <fieldset id={id} className={className}>
      {header && (
        <legend className="mb-comfy-xl mt-comfy-xl heading-sm">{header}</legend>
      )}
      <div className="flex flex-col gap-comfy-sm">{children}</div>
    </fieldset>
  );
};
